import React from 'react';
import { Col, Row, Card, Divider, Button } from 'antd';
import { Link } from "react-router-dom";
import './index.less';
import Dictionary from '../../../components/Dictionary'


export default ({ section, type, image, image_title, image_alt, title, content, link, index }) => {
  let layout = null;
  if (type === 'listing__newsevents') {
    layout = (
      <>
        <Divider orientation="left"></Divider>
        <div>
          <Row justify='start'>
            <Col xs={24} sm={24} md={12} lg={8}>
              <div className="listing__imagem">
                <img
                  src={`/images/${section}/${image}`}
                  alt={image_alt}
                  title={image_title}
                />
              </div>
            </Col>
            <Col className='style_text' xs={24} sm={24} md={12} lg={12}>
              
              <div className="title_content">
              <small>{index + 1}</small>
                {title ?
                  <h1>
                    {title}
                  </h1>
                  : null}
                <div>
                  <span dangerouslySetInnerHTML={{ __html: content }}></span>
                  <Button type='primary'>
                    {link.indexOf('//') >= 0 ?
                      <a href={link} target="_blank">
                        <Dictionary entry="see_more" oneLine /></a>
                      : null}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }else if (type === 'listing_research') {
    layout = (
      <>
        <Divider orientation="left"></Divider>
        <div>
          <Row justify='start'>
            <Col className='style_text' xs={24} sm={24} md={12} lg={12}>
              <div className="title_content">
                {title ?
                  <h1>
                    {title}
                  </h1>
                  : null}
                <div>
                  <span dangerouslySetInnerHTML={{ __html: content }}></span>
                  <Button type='primary'>
                    {link.indexOf('//') >= 0 ?
                      <a href={link} target="_blank">
                        <Dictionary entry="see_more" oneLine /></a>
                      : null}
                  </Button>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8}>
              <div className="listing__imagem">
                <img
                  src={`/images/${section}/${image}`}
                  alt={image_alt}
                  title={image_title}
                />
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
    } else if (type === 'listing__media') {
    layout = (
      <>
        <Divider orientation="left" />
        <div className="site-card-wrapper">
          <Row gutter={16} align="middle" justify="center">
            <Col xs={24} sm={24} md={12} lg={24}>
              <Card
                title={title}
                hoverable
              >
                <span dangerouslySetInnerHTML={{ __html: content }}></span>
                <Button type='primary'>
                    {link.indexOf('//') >= 0 ?
                      <a href={link} target="_blank">
                        <Dictionary entry="see_more" oneLine /></a>
                      : null}
                  </Button>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  } else if (type === 'listing_itens') {
    layout = (
      <>
        <Divider orientation="left" />
        <div className="site-card-wrapper">
          <Row gutter={16} align="middle" justify="center">
            <Col xs={24} sm={24} md={12} lg={24}>
              <Card
                title={title}
                hoverable
              >
                <span dangerouslySetInnerHTML={{ __html: content }}></span>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  } else if (type === 'listing_publicationss') {
    layout = (
      <div className="listing_publications">
        <div className="listing_publications_content">
          <li dangerouslySetInnerHTML={{ __html: content }}></li>
        </div>
      </div>

    );
  } else if (type === 'listing_publications') {
    layout = (
      <>
        <Divider orientation="left"></Divider>
        <div>
          <Row justify='start'>
            <Col xs={24} sm={24} md={12} lg={8}>
              <div className="listing__imagem">
                <img
                  src={`/images/${section}/${image}`}
                  alt={image_alt}
                  title={image_title}
                />
              </div>
            </Col>
            <Col className='style_text' xs={24} sm={24} md={12} lg={12}>
              <div className="title_content">
                {title ?
                  <h1>
                    {title}
                  </h1>
                  : null}
                <div>
                  <span dangerouslySetInnerHTML={{ __html: content }}></span>
                  <Button type='primary'>
                    {link.indexOf('//') >= 0 ?
                      <a href={link} target="_blank">
                        <Dictionary entry="see_more" oneLine /></a>
                      : null}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </>
    );
  }
   else {
    layout = (
      <li className="listing_item" style={{ backgroundImage: `url(/images/${section}/${image})` }}>
        <div className={`item__${type}`}>
          <h1>{title}</h1>
          <div dangerouslySetInnerHTML={{ __html: content }}></div>
        </div>
      </li>
    );
  }
  return (
    layout
  );
}
